import styled from '@emotion/styled'
import { Grid, Skeleton, StyledProps } from '@yuno/design-system-web'
import { ConnectionCardError } from '../connection-card-error'
import ConnectionPaymentMethodCard from '../connection-payment-method-card'

type ConnectionPaymentMethodProps = {
  paymentMethods: Array<PaymentMethod>
  isLoading: boolean
}

type PaymentMethod = {
  name: string
  icon: string
  hint: string
}

const Container = styled(Grid)`
  margin-top: 20px;
  margin-left: 20px;
`

const Item = styled(Grid)`
  margin: 0px 20px 20px 0px;
`

const SkeletonContainer = styled('div')<StyledProps>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px;
  gap: 10px;
  width: 253px;
  height: 64px;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 4px;
  margin-right: 20px;
  margin-bottom: 20px;
`

const SkeletonAvatar = styled(Skeleton)(() => ({
  width: 44,
  height: 44,
}))

const SkeletonText = styled(Skeleton)(() => ({
  width: 147,
  height: 20,
  marginTop: 12,
}))

export const ConnectionPaymentMethod = ({
  paymentMethods,
  isLoading = false,
}: ConnectionPaymentMethodProps) => {
  return (
    <Container container>
      {paymentMethods?.length
        ? paymentMethods?.map((paymentMethod, index) => {
            return (
              <Item item key={index}>
                <ConnectionPaymentMethodCard
                  title={paymentMethod?.name}
                  img={paymentMethod?.icon}
                  description={paymentMethod?.hint}
                />
              </Item>
            )
          })
        : !isLoading && <ConnectionCardError />}
      {isLoading &&
        Array(4)
          .fill(1)
          .map((item, index) => (
            <SkeletonContainer key={index}>
              <SkeletonAvatar variant="rounded" />
              <SkeletonText variant="rounded" />
            </SkeletonContainer>
          ))}
    </Container>
  )
}
